import type { Category } from './types';

export const categories: Category[] = [
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    description: '最新明星动态、恋情曝光、私生活揭秘，娱乐圈最劲爆的八卦都在这里',
    icon: 'ri-star-line',
    count: 8,
  },
  {
    slug: 'zongyi-jieMu',
    name: '综艺节目',
    description: '热门综艺幕后花絮、争议事件、嘉宾爆料，综艺圈的那些事',
    icon: 'ri-tv-line',
    count: 5,
  },
  {
    slug: 'yingshi-zixun',
    name: '影视资讯',
    description: '新片定档、片场路透、票房数据、影视行业前沿动态',
    icon: 'ri-film-line',
    count: 5,
  },
  {
    slug: 'wanghong-redian',
    name: '网红热点',
    description: '网红翻车、直播事故、短视频平台最新爆款话题',
    icon: 'ri-live-line',
    count: 4,
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '引发全民讨论的社会事件、热门话题深度解读',
    icon: 'ri-fire-line',
    count: 4,
  },
];